import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, BreadcrumbProps, Button, Divider, Flex } from 'antd';
import { FC, memo, useMemo } from 'react';
import { useFolder } from 'services';
import { useActiveFolderId, useIsRootFolder, useSetActiveFolderId } from '../../../store/filepicker.store';
import styles from './FilesBreadcrumb.module.scss';

type FilesBreadcrumbProps = {};

type BreadcrumbItemProps = {
  title?: string;
  onClick?: () => void;
  isRoot?: boolean;
};

const FilesBreadcrumbItem: FC<BreadcrumbItemProps> = ({ title, onClick = () => {}, isRoot = false }) => {
  return (
    <Button
      type={isRoot ? 'default' : 'text'}
      style={{ backgroundColor: 'transparent', padding: 0, border: 'none', outline: 'none' }}
      onClick={onClick}
    >
      <span>{isRoot ? <HomeOutlined /> : title}</span>
    </Button>
  );
};

const FilesBreadcrumb: FC<FilesBreadcrumbProps> = () => {
  const activeFolderId = useActiveFolderId();
  const setActiveFolder = useSetActiveFolderId();
  const isRootFolder = useIsRootFolder();
  const { data: folderData } = useFolder({
    id: activeFolderId,
  });

  const breadcrumbItems = useMemo<BreadcrumbProps['items']>(() => {
    if (folderData?.folder?.breadcrumb_folders?.length && folderData?.folder?.breadcrumb_folders.length > 1) {
      return folderData?.folder?.breadcrumb_folders.map((folder) => {
        const isRoot = isRootFolder(folder.id);
        return {
          title: (
            <FilesBreadcrumbItem
              key={folder.id || 'key'}
              title={folder.name}
              onClick={() => setActiveFolder(folder.id)}
              isRoot={isRoot}
            />
          ),
        };
      });
    }
  }, [folderData?.folder?.breadcrumb_folders, setActiveFolder, folderData?.folder, isRootFolder]);
  if (!breadcrumbItems?.length) {
    return null;
  }
  return (
    <div className={styles.breadcrumbContainer}>
      <Flex align="center">
        {!isRootFolder(activeFolderId) && (
          <Button
            style={{ paddingLeft: 0, marginRight: 15 }}
            icon={<ArrowLeftOutlined />}
            onClick={() => {
              setActiveFolder(folderData?.folder?.parent_id);
            }}
            size="small"
          />
        )}

        {/* <span>|</span> */}
        <Breadcrumb items={breadcrumbItems} style={{ marginBottom: '5px' }} separator={<span>/</span>} />
      </Flex>
      <Divider style={{ marginTop: 0, marginBottom: 0 }} />
    </div>
  );
};

const MemoFilesBreadcrumb = memo(FilesBreadcrumb);

export { MemoFilesBreadcrumb as FilesBreadcrumb };
